import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class CategoryId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): CategoryId {
    if (!(value.length > 0)) {
      throw new Error('内容が入力されていません');
    }
    return new CategoryId(value);
  }

  /**
   * ラベル
   */
  static get label(): string {
    return 'カテゴリID';
  }

  /**
   * PlaceHolder
   */
  static get placeholder(): string {
    return 'カテゴリID';
  }

  /**
   * バリデーションルール
   */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
      /** パターン */
      /** パターン */
      pattern: {
        /** 値 */
        value: /^([a-zA-Z0-9.]){1,20}$/,
        /** メッセージ */
        message: '1文字以上かつ20文字以下かつアルファベット小文字、大文字、数字である必要があります',
      },
    };
  }

  /**
   * キー
   */
  static get key(): string {
    return 'categoryId';
  }

  /**
   * タイプ
   */
  static get type(): string {
    return 'text';
  }

  /**
   * 表示を返す
   * @returns 表示
   */
  override toString() {
    return this.value;
  }
}
